/* eslint-disable @typescript-eslint/no-var-requires */
const ICO_CLOSE_ERROR = require("./images/ico_close_error.svg");
const ICO_CLOSE_INFO = require("./images/ico_close_info.svg");
const ICO_CLOSE_SUCCESS = require("./images/ico_close_success.svg");
const ICO_PHONE = require("./images/ico_phone.svg");
const IMG_RENTIO_LOGO = require("./images/img_rentio_logo@3x.png");

export const ASSETS_UNMAPPED = {
  ICO_CLOSE_ERROR,
  ICO_CLOSE_INFO,
  ICO_CLOSE_SUCCESS,
  ICO_PHONE,
  IMG_RENTIO_LOGO,
};
